"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileProductNotification = exports.DesktopProductNotification = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var NotificationContent_1 = require("./NotificationContent");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_common_1 = require("@ryerson/frontend.common");

var HelperFunctions_1 = require("./HelperFunctions");

var frontend_common_2 = require("@ryerson/frontend.common");

var StylesComponents_1 = require("./StylesComponents");

var frontend_navigation_1 = require("@ryerson/frontend.navigation");

var Pricing_content_1 = require("./Pricing.content");

var Application_1 = require("../Application");

var getPriceContentDisplay = function getPriceContentDisplay(priceData, language) {
  var hasExtendedPrice = typeof priceData !== "undefined";
  var isZero = priceData === 0;
  var displayPriceString = Pricing_content_1.PricingContent[language].inCart;

  if (hasExtendedPrice && !isZero) {
    displayPriceString = "".concat((0, frontend_common_1.displayPrice)(priceData));
  }

  return displayPriceString;
};

var isGUID = function isGUID(item) {
  var regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return !!item.match(regex);
};

var ProductNameLink = function ProductNameLink(_ref) {
  var product = _ref.product,
      storeDirectory = _ref.storeDirectory;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var lightBlue = theme.colors.secondary.lightBlue;
  return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
    children: !!(product === null || product === void 0 ? void 0 : product.altPartNumber) || !!(product === null || product === void 0 ? void 0 : product.fastPath) ? (0, jsx_runtime_1.jsx)(StylesComponents_1.NotificationLink, {
      css: {
        marginTop: "15px"
      },
      color: lightBlue,
      children: !!(product === null || product === void 0 ? void 0 : product.id) && isGUID(product === null || product === void 0 ? void 0 : product.id) ? (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
        size: "md",
        to: (0, frontend_common_2.navigateToProductDetails)(product === null || product === void 0 ? void 0 : product.id, // note: needs to be Magenium GUID, not all api's are doing this
        product === null || product === void 0 ? void 0 : product.altPartNumber, storeDirectory),
        children: (0, frontend_common_2.determineProductDisplay)(product === null || product === void 0 ? void 0 : product.altPartNumber, product === null || product === void 0 ? void 0 : product.fastPath)
      }) : (0, jsx_runtime_1.jsx)("span", {
        children: (0, frontend_common_2.determineProductDisplay)(product === null || product === void 0 ? void 0 : product.altPartNumber, product === null || product === void 0 ? void 0 : product.fastPath)
      })
    }) : (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
      color: lightBlue,
      size: "md",
      variant: "p",
      children: (product === null || product === void 0 ? void 0 : product.materialMaster) || (product === null || product === void 0 ? void 0 : product.id)
    })
  });
};

var DesktopProductNotification = function DesktopProductNotification(_ref3) {
  var product = _ref3.product,
      index = _ref3.index,
      storeDirectory = _ref3.storeDirectory;

  var _a;

  var _ref4 = (0, frontend_theme_1.useTheme)(),
      theme = _ref4.theme;

  var _ref5 = (0, Application_1.useApplication)(),
      language = _ref5.localization.language;

  var lighterGray = theme.colors.primary.lighterGray;
  var darkBlue = theme.colors.secondary.darkBlue;
  var content = NotificationContent_1.NotificationContent[language] || NotificationContent_1.NotificationContent.en;
  return (0, jsx_runtime_1.jsxs)(StylesComponents_1.NotificationContainer, {
    children: [(0, jsx_runtime_1.jsxs)(StylesComponents_1.NotificationImageContainer, {
      imageBorderColor: lighterGray,
      children: [(0, jsx_runtime_1.jsx)("img", {
        onError: function onError(event) {
          return (0, HelperFunctions_1.addImageDefaultSrc)(event);
        },
        src: "".concat(HelperFunctions_1.staticAssetsUrl).concat((0, frontend_common_2.toPascalCase)(product === null || product === void 0 ? void 0 : product.category)).concat((0, frontend_common_2.toPascalCase)(product === null || product === void 0 ? void 0 : product.form)).concat((product === null || product === void 0 ? void 0 : product.shape) !== "N/A" ? (0, frontend_common_2.toPascalCase)(product === null || product === void 0 ? void 0 : product.shape) : "", ".png"),
        width: "100%"
      }), (0, jsx_runtime_1.jsx)(ProductNameLink, {
        product: product,
        storeDirectory: storeDirectory
      })]
    }), (0, jsx_runtime_1.jsxs)(StylesComponents_1.PriceContainer, {
      direction: "column",
      children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        size: "sm",
        variant: "p",
        children: (0, HelperFunctions_1.determineProductName)(product) || "".concat(content.alt, " ").concat(product.materialMaster, " ").concat((_a = product.description) === null || _a === void 0 ? void 0 : _a.replace(/<br\/>/gi, ""))
      }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        justifyContent: "space-between",
        children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          size: "xs",
          children: "".concat(content.leadTime, " ").concat(product.leadTimeDisplay)
        }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          size: "xs",
          children: content.extendedPrice
        })]
      }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        justifyContent: "space-between",
        children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
          children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "xs",
            children: content.qty
          }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "xs",
            color: darkBlue,
            children: "".concat(product.quantity, " ").concat((0, HelperFunctions_1.getDisplayUom)(product.quantityUOM))
          })]
        }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          size: "sm",
          weight: "bolder",
          color: darkBlue,
          children: getPriceContentDisplay(product.extendedPrice, language)
        })]
      })]
    })]
  }, index);
};

exports.DesktopProductNotification = DesktopProductNotification;

var MobileProductNotification = function MobileProductNotification(_ref6) {
  var product = _ref6.product,
      index = _ref6.index,
      storeDirectory = _ref6.storeDirectory;

  var _a;

  var _ref7 = (0, frontend_theme_1.useTheme)(),
      theme = _ref7.theme;

  var _ref8 = (0, Application_1.useApplication)(),
      language = _ref8.localization.language;

  var lighterGray = theme.colors.primary.lighterGray;
  var darkBlue = theme.colors.secondary.darkBlue;
  var content = NotificationContent_1.NotificationContent[language] || NotificationContent_1.NotificationContent.en;
  return (0, jsx_runtime_1.jsxs)(StylesComponents_1.NotificationContainer, {
    children: [(0, jsx_runtime_1.jsx)(StylesComponents_1.NotificationImageContainer, {
      imageBorderColor: lighterGray,
      children: (0, jsx_runtime_1.jsx)("img", {
        onError: function onError(event) {
          return (0, HelperFunctions_1.addImageDefaultSrc)(event);
        },
        src: "".concat(HelperFunctions_1.staticAssetsUrl).concat((0, frontend_common_2.toPascalCase)(product === null || product === void 0 ? void 0 : product.category)).concat((0, frontend_common_2.toPascalCase)(product === null || product === void 0 ? void 0 : product.form)).concat((product === null || product === void 0 ? void 0 : product.shape) !== "N/A" ? (0, frontend_common_2.toPascalCase)(product === null || product === void 0 ? void 0 : product.shape) : "", ".png"),
        width: "100%"
      })
    }), (0, jsx_runtime_1.jsxs)(StylesComponents_1.PriceContainer, {
      direction: "column",
      children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        children: (0, jsx_runtime_1.jsx)(ProductNameLink, {
          product: product,
          storeDirectory: storeDirectory
        })
      }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
        children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          size: "md",
          variant: "p",
          children: (0, HelperFunctions_1.determineProductName)(product) || "".concat(content.alt, " ").concat(product.materialMaster, " ").concat((_a = product.description) === null || _a === void 0 ? void 0 : _a.replace(/<br\/>/gi, ""))
        })
      }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        justifyContent: "space-between",
        children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          size: "xs",
          children: "".concat(content.leadTime, " ").concat(product.leadTimeDisplay)
        }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          size: "xs",
          children: content.extendedPrice
        })]
      }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        justifyContent: "space-between",
        children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
          children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "xs",
            children: content.qty
          }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "xs",
            color: darkBlue,
            children: "".concat(product.quantity, " ").concat((0, HelperFunctions_1.getDisplayUom)(product.quantityUOM))
          })]
        }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          size: "sm",
          weight: "bolder",
          color: darkBlue,
          children: getPriceContentDisplay(product.extendedPrice, language)
        })]
      })]
    })]
  }, index);
};

exports.MobileProductNotification = MobileProductNotification;